"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryReducer = exports.QueryCleanup = exports.QUERY_CLEANUP = void 0;
const GeneralConstants_1 = require("../../Utilities/Constants/GeneralConstants");
/**
 * @ReduxAction Deletes query state
 */
exports.QUERY_CLEANUP = 'QUERY_CLEANUP';
const QueryCleanup = () => ({
    type: exports.QUERY_CLEANUP,
});
exports.QueryCleanup = QueryCleanup;
const initialState = {
    NamedQueries: GeneralConstants_1.EMPTY_ARRAY,
    CurrentQuery: GeneralConstants_1.EMPTY_STRING,
};
const QueryReducer = (state = initialState, action) => {
    switch (action.type) {
        case exports.QUERY_CLEANUP:
            return initialState;
        default:
            return state;
    }
};
exports.QueryReducer = QueryReducer;
